import clsx from 'clsx';
import { useNavigate } from 'react-router';
import { Icon } from '@/design-system';
import { ns, useT } from '@/i18n';
import type { Universe } from '@/services/domain';
import { usePlatformConfig } from '@/services/queries';
import { paths } from '../paths';
import styles from './UniverseSwitch.module.css';

interface Props {
  universe: Universe;
  compact?: boolean;
  overHero?: boolean;
}

/** Véhicules ⇄ Expériences (`.sw`). */
export function UniverseSwitch({ universe, compact = false, overHero = false }: Props) {
  const navigate = useNavigate();
  const t = useT(ns.shell);
  const tc = useT(ns.common);
  const { data: config } = usePlatformConfig();
  const expEnabled = config?.activitiesEnabled ?? true;
  return (
    <nav className={clsx(styles.sw, compact && styles.compact, overHero && styles.over)} aria-label={t('universes')}>
      <button
        type="button"
        className={clsx(styles.item, universe === 'veh' && styles.on)}
        aria-pressed={universe === 'veh'}
        onClick={() => navigate(paths.home)}
      >
        <Icon name="car" size={compact ? 17 : 20} />
        <span>{tc('vehicles')}</span>
      </button>
      <button
        type="button"
        className={clsx(styles.item, universe === 'exp' && styles.on)}
        aria-pressed={universe === 'exp'}
        disabled={!expEnabled}
        onClick={() => navigate(paths.experiences)}
      >
        <Icon name="balloon" size={compact ? 17 : 20} />
        <span>{tc('experiences')}</span>
        {!compact && <span className={styles.new}>{expEnabled ? tc('new') : tc('soon')}</span>}
      </button>
    </nav>
  );
}
